import { createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from '../../constants';
import { ReportIssueState } from './reportIssue.types';
import { reportIssue, reportIncorrectReport } from './reportIssue.thunks';
import { reportIssueStoreKey } from './reportIssue.const';
import { DataState } from '../../types/asyncData';

const initialState: ReportIssueState = {
  apiStatus: DataState.Idle,
};

export const reportIssueSlice = createSlice({
  name: reportIssueStoreKey,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reportIssue.pending, (state) => {
        state.apiStatus = DataState.Pending;
      })
      .addCase(reportIssue.fulfilled, (state) => {
        state.apiStatus = DataState.Fulfilled;
      })
      .addCase(reportIssue.rejected, (state) => {
        state.apiStatus = DataState.Rejected;
      });

    builder
      .addCase(reportIncorrectReport.pending, (state) => {
        state.apiStatus = DataState.Pending;
      })
      .addCase(reportIncorrectReport.fulfilled, (state) => {
        state.apiStatus = DataState.Fulfilled;
      })
      .addCase(reportIncorrectReport.rejected, (state) => {
        state.apiStatus = DataState.Rejected;
      });
  },
});
